// Terminologie maritime : « compas magnétique », « compensation » pour la correction des
// déviations, « table de déviation » pour la deviation card, « société de classification ».
// Espaces insécables ( ) avant ? ! ; : selon la typographie française.
const fr = {
    nav: {
        about: 'À propos',
        services: 'Services',
        contact: 'Contact',
        language: 'Langue',
    },
    slides: {
        s1Subtitle: 'Services et certificats pour compas magnétiques depuis 1939.',
        readAbout: 'À propos de nous',
        s2Before: 'Nous sommes la première entreprise à proposer la ',
        s2Highlight: 'compensation à distance',
        s2After: ' des compas magnétiques.',
        s2Text: 'Faites compenser votre compas magnétique à distance et obtenez tous les certificats nécessaires à présenter à toute autorité nationale ou internationale.',
        learnMore: 'En savoir plus',
        getQuote: 'Demander un devis',
        imgAlt: "Passerelle d'un navire avec équipements de navigation",
    },
    about: {
        title: 'À propos',
        imgAlt: "Compas magnétique sur le pont d'un navire",
        since: 'Depuis',
        eyebrow: 'Qui sommes-nous',
        heading: 'Nous réparons et étalonnons des compas magnétiques depuis plus de 85 ans.',
        text: 'Seul laboratoire agréé en Argentine à délivrer des certificats dotés de toutes les validations légales et internationales, reconnus dans le monde entier par toute société de classification ou autorité de garde-côtes.',
        checks: [
            "Agréés par la PNA (Argentine, État membre de l'OMI)",
            "Premier service d'étalonnage de compas entièrement à distance",
            'Étalonnage de compas magnétiques et certificats en moins de 24 h',
        ],
        counters: ['Certificats délivrés', 'Compas réparés', 'Interventions réalisées'],
        partner: 'Service officiel et distributeur',
    },
    services: {
        title: 'Services',
        flagship: 'Notre service phare',
        remoteTitle: 'Étalonnage à distance',
        remoteSubtitle: 'Étalonnez votre compas magnétique en navigation, partout dans le monde. Sans technicien à bord, sans escale.',
        steps: [
            { title: 'Transmettez les données.', text: 'Le capitaine télécharge les informations du compas sur notre plateforme en ligne.' },
            { title: 'Recevez les instructions.', text: 'Des étapes simples et détaillées pour corriger les déviations.' },
            { title: 'Compensez avec notre assistance.', text: 'Un technicien est disponible 24 h/24, 7 j/7, pour répondre à toutes vos questions.' },
            { title: 'Recevez les certificats.', text: 'La nouvelle table de déviation et les certificats par e-mail.' },
        ],
        imgAlt: 'Plateforme en ligne',
        figcaption: 'Toutes les informations du compas au même endroit, sur notre plateforme en ligne.',
        advShipTitle: 'Avantages pour le navire',
        advShip: [
            'Compensation en navigation, sans escale ni retard du voyage',
            'Un technicien disponible 24 h/24, 7 j/7',
        ],
        advOwnersTitle: 'Avantages pour les armateurs et gestionnaires',
        advOwners: [
            "Aucun frais d'embarquement ni de débarquement du technicien",
            "Forfait fixe, sans supplément selon le jour ou l'heure ; plus avantageux en volume",
        ],
        howItWorks: 'Comment ça marche',
        onboardTitle: 'Étalonnage à bord',
        onboardText: 'Un technicien à bord compense manuellement le compas magnétique et délivre les certificats, signés électroniquement par le technicien et le capitaine.',
        onboardSteps: [
            'Le technicien indique au capitaine les manœuvres à effectuer pour contrôler et compenser le compas magnétique si nécessaire.',
            'Une fois toutes les déviations corrigées, le technicien délivre à bord les certificats dotés de toutes les validations légales et internationales. Ils sont signés électroniquement par le technicien et le capitaine.',
        ],
        repairTitle: 'Réparation de compas magnétiques',
        repairText: "Envoyez ou apportez votre compas à notre laboratoire. Réparé en moins de 24 heures, avec certificat de révision et garantie d'un an.",
        repairSteps: [
            "Le compas magnétique est inspecté afin d'identifier le problème.",
            "L'un de nos techniciens le répare en moins de 24 heures.",
            "Une fois réparé, notre technicien délivre le certificat de révision du compas, garantie d'un an incluse.",
        ],
    },
    contact: {
        title: 'Contact',
        intro: "Besoin d'un devis ou d'un renseignement ? Nos techniciens vous répondront.",
        getInTouch: 'Contactez-nous',
        getInTouchText: 'Appelez-nous, écrivez-nous ou envoyez-nous un message. Nous répondons partout dans le monde.',
        international: 'États-Unis / International',
        technical: 'Service technique',
        email: 'E-mail',
        laboratory: 'Laboratoire',
        openMaps: 'Ouvrir dans Maps',
        whatsapp: 'Écrire sur WhatsApp',
        showEmail: "Afficher l'e-mail",
        form: {
            title: 'Envoyez-nous un message',
            required: 'Tous les champs sont obligatoires.',
            name: 'Nom complet',
            email: 'E-mail',
            phone: 'Téléphone portable',
            enterprise: 'Entreprise',
            subject: 'Objet',
            message: 'Message',
            recaptcha: 'Protégé par reCAPTCHA.',
            send: 'Envoyer le message',
            sending: 'Envoi en cours... Veuillez patienter.',
            sendError: "Une erreur s'est produite ! Veuillez réessayer plus tard ou nous écrire directement par e-mail.",
        },
        errors: {
            name: 'Le nom est obligatoire',
            email: "L'e-mail est obligatoire",
            emailInvalid: "L'e-mail n'est pas valide",
            phone: 'Le téléphone portable est obligatoire',
            enterprise: "L'entreprise est obligatoire",
            subject: "L'objet est obligatoire",
            message: 'Le message est obligatoire',
        },
    },
    footer: {
        slogan: 'Services et certificats pour compas magnétiques depuis 1939',
        terms: 'Conditions générales',
        policy: 'Confidentialité',
    },
}

export default fr
